import type { FieldProps } from 'formik';
import { Field } from 'formik';
import React from 'react';
import type { ButtonWithLoadingStateProps } from '../Button';
import { ButtonWithLoadingState } from '../Button';

const FormikSubmitButton = ({
  disabled = false,
  ...props
}: Omit<ButtonWithLoadingStateProps, 'loading'>) => (
  <Field name="__submitButton">
    {({ form: { isSubmitting } }: FieldProps) => (
      <ButtonWithLoadingState
        type="submit"
        variant="primary"
        {...props}
        loading={isSubmitting}
        disabled={disabled}
      >
        {props.children}
      </ButtonWithLoadingState>
    )}
  </Field>
);

export default FormikSubmitButton;
